// extracted by mini-css-extract-plugin
export default {"container":"EditorFontSize_container__l+aQv","input":"EditorFontSize_input__tIYqJ"};